/*

sohel  09/26/2022  2698947782 Custom Windows -> Added Window Owner Field, columns to dashboard table bugfixes.
usha   09/29/2022  2698947782 Customization in custom window
ashraf 10/06/2022  2698947782 added comments to code, removed unusual code
ashraf 10/15/2022  2698947782 Added custom windows code comments
ashraf 10/27/2022  2698947782 custom window UX changes
suresh peddavoora 10/28/2022 2698947782  Removed class name for card, added class name for dashboard section
ashraf 10/30/2022 2698947782 conditional tabs render
Gummala Prakash 11/28/2022 2698947782 Removed card-component.
Ashraf 12/05/2022 2698947782 Fixed header labels
*/

import React from 'react';
import LandingPage from '../../Pages/LandingPage';
import Tabs from './Tabs';

export default function UDW() {
  const [mainTabValue, setMainValue] = React.useState(0);
  const tabs = ['Custom Windows'];

  // To handle tab change
  const handleChange = (event, newValue) => {
    setMainValue(newValue);
  };

  return (
    <>
      <LandingPage title={'Administration'} showTabs={true} allAntTabs={tabs} tabValue={mainTabValue} handleTabChange={handleChange} >
        <div className={`col-md-12 global-field-dash-board p-0`}>
          <div>
            <Tabs value={mainTabValue} />
          </div>
        </div>
      </LandingPage>
    </>
  );
}

